// extend TrimbleMaps Marker so we can pass in an onClick handler
// TrimbleMaps is loaded via CDN and available as window.TrimbleMaps

const makiNames = require('@mapbox/maki/layouts/all.json');

class ClickableMarker {
  constructor(options, legacyOptions) {
    const TrimbleMaps = window.TrimbleMaps;

    // Create a base marker using TrimbleMaps.Marker
    this._marker = new TrimbleMaps.Marker(options, legacyOptions);
    this._element = this._marker.getElement();

    const { symbol = 'circle', symbolColor = '#fff' } = options;

    if (
      symbol != 'circle' &&
      (makiNames.includes(symbol) || /^[a-z0-9]$/.test(symbol))
    ) {
      const circleEl = this._element.querySelector('circle');
      if (circleEl) {
        const symbolPath = document.createElement('path');
        circleEl.replaceWith(symbolPath);

        // download svg symbol and insert its path where the circle was
        d3.xml(`../dist/icons/${symbol}.svg`, function (err, xml) {
          if (err) {
            console.error(
              `Error downloading the svg from: ../dist/icons/${symbol}.svg`
            );
          } else {
            symbolPath.outerHTML = `<path fill="${symbolColor}" transform="translate(6 6)"
              d="${xml.documentElement
                .getElementsByTagName('path')[0]
                .getAttribute('d')}"></path>`;
          }
        });
      }
    }
  }

  // Proxy methods to the underlying marker
  setLngLat(lngLat) {
    this._marker.setLngLat(lngLat);
    return this;
  }

  addTo(map) {
    this._marker.addTo(map);
    return this;
  }

  remove() {
    this._marker.remove();
    return this;
  }

  getElement() {
    return this._marker.getElement();
  }

  getLngLat() {
    return this._marker.getLngLat();
  }

  // new method onClick, sets _handleClick to a function you pass in
  onClick(handleClick) {
    this._handleClick = handleClick;

    // Add click listener to the element
    this._element.addEventListener('click', (e) => {
      if (this._handleClick) {
        e.stopPropagation();
        this._handleClick();
      }
    });

    return this;
  }
}

module.exports = ClickableMarker;
